// StatusIcons.jsx
import React from 'react';
import './StatusIcons.css'; // 放閃爍動畫的 CSS

const baseStyle = {
    width: '1.2em',
    height: '1.2em',
    verticalAlign: 'middle',
    marginRight: '4px', // 燈號和文字之間留距離
};

function LedIcon({ color, glow, blinking }) {
    return (
        <svg
            viewBox="0 0 24 24"
            style={baseStyle}
            className={blinking ? 'led-blink' : ''}
        >
            {/* 外圈陰影 */}
            <circle cx="12" cy="12" r="10" fill="#111" />
            {/* 主體漸層 */}
            <circle
                cx="12"
                cy="12"
                r="9"
                fill={`url(#grad-${color})`}
                stroke={glow}
                strokeWidth="1"
            />
            {/* 高光 */}
            <ellipse cx="9" cy="8" rx="4" ry="2" fill="white" opacity="0.6" />

            <defs>
                <radialGradient id={`grad-${color}`} cx="30%" cy="30%" r="70%">
                    <stop offset="0%" stopColor="white" stopOpacity="0.9" />
                    <stop offset="40%" stopColor={glow} stopOpacity="0.9" />
                    <stop offset="100%" stopColor={color} />
                </radialGradient>
            </defs>
        </svg>
    );
}

export const GreenIcon = () => <LedIcon color="#16a34a" glow="#4ade80" />;
export const YellowIcon = ({ blinking }) => (
    <LedIcon color="#f59e0b" glow="#facc15" blinking={blinking} />
);
export const RedIcon = ({ blinking }) => (
    <LedIcon color="#dc2626" glow="#f87171" blinking={blinking} />
);
export const GrayIcon = () => <LedIcon color="#6b7280" glow="#9ca3af" />;
